export const SUBORG_NAME_IS_NOT_UNIQUE_MSG =
  'This organization name is already taken';
export const SUBORG_NAME_IS_NOT_SPECIFIED_MSG =
  'Please provide a suborganization name';
export const DEFAULT_ERROR_MSG = 'Something went wrong';
